import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'phx-table-cell-icon',
  template: '<ng-content></ng-content>',
  styleUrls: ['./phx-table-cell-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-table-cell-icon',
  },
})
export class PhxTableCellIconComponent {}
